const validateCbtTaxes = ({ map_content, title, tooltip }) => {
  if (map_content) {
    return null;
  }

  return { ...title, onHover: !!tooltip };
};

export default validateCbtTaxes;
